<div class="map-delete-container">
  @if (!downgradeResponse?.cleanup_required) {
    <div class="header">
      <!-- Close button only, no title as per screenshot -->
      <button type="button" class="close" aria-label="Close" (click)="close()">
        <img src="assets/icons/icon-close.svg" alt="Close">
      </button>
    </div>
  }

  <div class="delete-content">
    <div class="info-text mb-4">
      <p class="text-white mb-3">While we work in the background to update your account...</p>
      <p class="text-white mb-3">Please share with us what prompted the account change?</p>

      @if (progressState) {
        <div class="progress-indicator mt-3">
          <p class="m-0" [ngClass]="{'text-success': progressState.status === 'complete', 'text-danger': progressState.status === 'error', 'text-info': progressState.status === 'progress'}" style="font-size: 0.9rem;">
            @if (progressState.status === 'progress') {
              <i class="fa fa-spinner fa-spin me-2"></i>
            }
            @if (progressState.status === 'complete') {
              <i class="fa fa-check me-2"></i>
            }
            @if (progressState.status === 'error') {
              <i class="fa fa-times me-2"></i>
            }
            {{ progressState.message }}
          </p>
        </div>
      }
    </div>

    <div class="text-area-container" [formGroup]="feedbackForm">
      <textarea formControlName="feedback" placeholder="" [class.is-invalid]="submitted && f['feedback'].errors">
      </textarea>

      @if (submitted && f['feedback'].errors) {
        <div class="validation-errors">
          @if (f['feedback'].errors?.['required']) {
            <div class="error-message">
              <span>Feedback is required.</span>
            </div>
          }
        </div>
      }
    </div>

    <div class="btn-sec mt-2">
      <div class="btn-group-custom">
        <button class="btn btn-green" (click)="submit()" [disabled]="isSubmitting || submitPending">{{isSubmitting || submitPending ?
        'Submitting...' : 'Submit'}}</button>
      </div>
    </div>
  </div>
</div>